import { useCallback } from 'react';
import {
  trackAnalytics,
  getDistinctWordsCount,
  getTextLength,
  getTokenCount,
} from 'common/components/CopyMagic/shared/dataHelpers';
import { useConfigContext } from 'common/components/CopyMagic/contexts';
import { ContentAssistantResultType } from 'common/components/CopyMagic/generators/ContentAssistant/ContentAssistant.types';
import { OPEN_AI_CODE_WRAPPER } from 'common/components/CopyMagic/constants';

type CallbackInput = {
  isSuccess: boolean;
  isModerated: boolean;
  result: ContentAssistantResultType;
  chatSessionId: string;
  clientDurationInSecs: number;
};

/*
useTrackPromptResponse trackingCallback
  Because of the invocation location of this tracking callback,
  a race condition can occur with `result` being set in the ResultContext,
  therefore we pass `result` as an arg instead.
*/

const useTrackPromptResponse = () => {
  const { productEvents } = useConfigContext();

  const trackCallback = useCallback(
    ({ isSuccess, isModerated, result, chatSessionId, clientDurationInSecs }: CallbackInput) => {
      const trackProductAnalytics = trackAnalytics(productEvents);
      const returnContent = result?.content || '';

      trackProductAnalytics('Generated', {
        'Is Success': isSuccess,
        'Chat Session ID': chatSessionId,
        'Content Moderated': isModerated,
        'Content ID': result?.id,
        'Text Length': getTextLength(result),
        'Word Count': getDistinctWordsCount(result),
        'Tokens Returned': getTokenCount(returnContent),
        'Message Includes Code': returnContent.includes(OPEN_AI_CODE_WRAPPER),
        'Client Duration in Secs': clientDurationInSecs,
      });
    },
    [productEvents],
  );

  return trackCallback;
};

export default useTrackPromptResponse;
